module.exports = __webpack_public_path__ + "static/media/about-btc.86de059c.jpg";